import { render, staticRenderFns } from "./registChooseOrg.vue?vue&type=template&id=fcab567c&scoped=true&"
import script from "./registChooseOrg.vue?vue&type=script&lang=js&"
export * from "./registChooseOrg.vue?vue&type=script&lang=js&"
import style0 from "./registChooseOrg.vue?vue&type=style&index=0&id=fcab567c&lang=scss&scoped=true&"
import style1 from "./registChooseOrg.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab567c",
  null
  
)

export default component.exports